export const SET_ROLE = "settings/SET_ROLE";

export const RESET_STATE = "settings/RESET_STATE";

export const setRole = role => ({ type: SET_ROLE, role });

const resetState = () => ({ type: RESET_STATE });

export const actions = {
  setRole,
  resetState
};

const SETTINGS_ACTION_HANDLERS = {
  [SET_ROLE]: (state, action) => ({ ...state, role: action.role }),
  [RESET_STATE]: state => ({ ...state, ...initialState })
};

export const initialState = {
  role: null
};

export default function settingsReducer(state = initialState, action) {
  const handler = SETTINGS_ACTION_HANDLERS[action.type];
  return handler ? handler(state, action) : state;
}
